var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8,0C4.691,0,2,2.691,2,6s2.691,6,6,6,6-2.691,6-6S11.309,0,8,0Zm0,11c-2.757,0-5-2.243-5-5S5.243,1,8,1s5,2.243,5,5-2.243,5-5,5Zm3.942,4.599c-.128.245-.431.338-.675.208-1-.528-2.129-.807-3.267-.807-3.86,0-7,3.14-7,7v1.5c0,.276-.224.5-.5.5s-.5-.224-.5-.5v-1.5c0-4.411,3.589-8,8-8,1.3,0,2.591.319,3.734.923.244.129.338.431.208.675Zm10.058-.26v-1.838c0-1.93-1.57-3.5-3.5-3.5s-3.5,1.57-3.5,3.5v1.838c-1.181.563-2,1.769-2,3.162v2c0,1.93,1.57,3.5,3.5,3.5h4c1.93,0,3.5-1.57,3.5-3.5v-2c0-1.393-.819-2.599-2-3.162Zm-6-1.838c0-1.378,1.122-2.5,2.5-2.5s2.5,1.122,2.5,2.5v1.536c-.163-.023-.33-.036-.5-.036h-4c-.17,0-.337.012-.5.036v-1.536Zm7,7c0,1.378-1.122,2.5-2.5,2.5h-4c-1.378,0-2.5-1.122-2.5-2.5v-2c0-1.378,1.122-2.5,2.5-2.5h4c1.378,0,2.5,1.122,2.5,2.5v2Zm-3.5-1c0,.552-.448,1-1,1s-1-.448-1-1,.448-1,1-1,1,.448,1,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLock);
export default __webpack_public_path__ + "static/media/user-lock.edb749b5590cab6eb4a0e786c451a4aa.svg";
export { ForwardRef as ReactComponent };